/**
 * SCSS IMPORT FILE
 * this file is just for scss imports which will create css classes
 */
import '@swisslife/shared-ui/src/base/bootstrap/css/bootstrap';
import '../../../atoms/button/css/button';
import '../../../atoms/link/css/link';
import '../../horizontal-nav/css/horizontal-nav';
import './modifier/hide-categories.scss';
import './list-filter.scss';
